
import axios from 'axios'

import * as types from '../mutation-types'

// state
export const state = {
    teste: {}
    // teste : {
    //   nome: 'ATIVIDADES PARA INTERVENÇÃO PSICOPEDAGÓGICA BLOCOS LÓGICOS',
    //   categoria : {nome: 'nome da categoria'},
    //   descricao : 'A Queixa é o primeiro passo para o Diagnóstico Psicopedagógico. Serve para iniciar o atendimento psicopedagógico e analisar quais os procedimentos deverão ser utilizadas.',
    //   perguntas:[
    //     {
    //       pergunta: 'A Queixa é o primeiro passo para o Diagnóstico Psicopedagógico. Serve para iniciar o atendimento psicopedagógico e analisar quais os procedimentos deverão ser utilizadas.',
    //       img: 'http://blog.psiqueasy.com.br/wp-content/uploads/2018/02/testes-psicopedaggicos-2-638-1.jpg',
    //       alternativas:{}
    //     },
    //     {
    //       pergunta: 'NÍVEL PEDAGÓGICO OU DIMENSÃO COGNITIVA:',
    //        img: '',
    //        alternativas:[
    //          {nome : 'Descreveu o que desenhou'},
    //          {
    //            nome : 'compreensão do texto é muito pobre',
    //            opcoes:[
    //              { nome: 'Classe média' },
    //              { nome: 'Baixa' }
    //            ]
    //          },
    //          {nome : 'apresenta baixo rendimento na área de ortografia'},
    //          {nome : 'Suspirou antes de começar a tarefa , indicando uma antecipação e planejamento do que iria realizar.'},
    //          {nome : 'apresenta ansiedade e medo na hora de ler em voz alta '}
    //        ]
    //     },
    //     {
    //       pergunta: 'A Queixa é o primeiro passo para o Diagnóstico Psicopedagógico. Serve para iniciar o atendimento psicopedagógico e analisar quais os procedimentos deverão ser utilizadas.',
    //       img: '',
    //       alternativas:[
    //           {nome : 'Sim'},
    //           {
    //             nome : 'Não',
    //             opcoes:[
    //               { nome: 'ope 1' },
    //               { nome: 'ope 2' }
    //             ]
    //           }
    //       ]
    //     },
    //     {
    //       pergunta: 'A Queixa é o primeiro passo para o Diagnóstico Psicopedagógico. Serve para iniciar o atendimento psicopedagógico e analisar quais os procedimentos deverão ser utilizadas.',
    //       img: 'http://blog.psiqueasy.com.br/wp-content/uploads/2018/02/xtestes-psicopedaggicos-4-638-1.jpg.pagespeed.ic.meyq67NF-S.jpg',
    //       alternativas:[
    //           {nome : 'Sim'},
    //           {nome : 'Não'}
    //       ]
    //     }
    //   ],
    //
    //   arrayPergunta: {
    //     nome: '',
    //     foto: '',
    //     anexo: '',
    //   }
    //
    // }
}

// actions
export const actions = {

  async setTeste ({ commit, dispatch }, id){
    commit(types.SET_TESTE, { teste : {} })
    try{
        const { data } = await axios.get('/api/testes-json/'+ id)
        commit(types.SET_TESTE, { teste : data })
    } catch (e) {
        dispatch('alert/erroAoCarregar', null ,{ root: true })
     }
  }

}

// mutations
export const mutations = {

  [types.SET_TESTE] (state, {teste}){
    state.teste = teste
  }

}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/teste.js